import { File } from '../file';
import { InternHeadlineRichtext } from '../intern/headline-richtext';
import { InternOverline } from '../intern/overline';
import { InternSubline } from '../intern/subline';
import { ContentButton } from './button';
import { ContentProductLinkList } from './product-link-list';
import { ContentServiceLinkList } from './service-link-list';
import { ContentTopInfoBox } from './top-info-box';
import { ContentTrustImages } from './trust-images';

/**
 * Model definition for Opener
 */
export interface ContentOpener {
  __component: 'content.opener';
  id: string;
  media?: File;
  openerVideo: { [key: string]: unknown };
  layout?:
    | 'homeImageRight'
    | 'homeImageLeft'
    | 'deviceImageRight'
    | 'deviceImageLeft'
    | 'productPage'
    | 'servicePage'
    | 'serviceAndCampaignPage';
  mediaFill: 'dark' | 'standard' | 'light' | 'none';
  overline?: InternOverline;
  headline?: InternHeadlineRichtext;
  firstSubline?: InternSubline;
  topInfoBox?: ContentTopInfoBox;
  secondSubline?: InternSubline;
  content?: (ContentProductLinkList | ContentServiceLinkList | ContentButton | ContentTrustImages)[];
  actions?: [];
}

export function isContentOpener(obj: { __component?: string }): obj is ContentOpener {
  return obj.__component === 'content.opener';
}

export function isFullPageContentOpener(obj: { __component?: string }): obj is ContentOpener {
  return (
    isContentOpener(obj) &&
    (obj.layout == 'productPage' || obj.layout == 'servicePage' || obj.layout == 'serviceAndCampaignPage')
  );
}
